"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_CREATE_ROLE_COUNT = void 0;
exports.MAX_CREATE_ROLE_COUNT = 12; // Owner(hidden) + Admin + Default + Custom x 10
